import type { ReactNode } from "react";

export interface StatusPillProps {
  children: ReactNode;
  tone?: "positive" | "warning" | "danger" | "neutral" | "info";
  dot?: boolean;
}

export function StatusPill({
  children,
  tone = "neutral",
  dot = true,
}: StatusPillProps) {
  return (
    <span className={`status-pill status-pill--${tone}`}>
      {dot && <i />}
      {children}
    </span>
  );
}
